import Picture from '../Picture';

type BannerProps = {
    children: React.ReactNode;
    src?: string;
    alt?: string;
    className?: string;
};

export default function Banner({
    children,
    src = 'onward-travel-solutions-banner',
    alt = 'Onward Travel Solutions Banner',
    className = '',
}: BannerProps) {
    return (
        <header
            className={`bg-gray-900 relative grid place-content-center isolate ${className}`}
        >
            <div className='-z-10 absolute inset-0'>
                <Picture
                    path={src}
                    alt={alt}
                    className='w-full h-full object-cover'
                />
            </div>
            <div className='space-y-10 m-auto px-5 max-w-3xl text-center'>
                {children}
            </div>
        </header>
    );
}
